module.exports = __webpack_public_path__ + "img/help-tooltip-error.6cf3bbdb.svg";